import graphql from 'babel-plugin-relay/macro';

const SendTicketToEmailQuery = graphql`
	query SendTicketToEmailQuery($bookingId: String!) {
		sendTicketToEmail(bookingId: $bookingId) 
	}`;

export default SendTicketToEmailQuery;